import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { i18n, useTranslation } from 'next-i18next';

import { traceEvent } from '@wk/wk-gatherer';
import cls from 'classnames';
import { isEmpty } from 'lodash';

import { activityStudentType, RenewalEntriesType } from '@/api/types/renewal';

import style from './style.module.scss';

interface IProps {
  data?: RenewalEntriesType;
  dsSource?: string;
}

const RenewalEntry = (props: IProps) => {
  const { data, dsSource } = props;
  const router = useRouter();
  const { t } = useTranslation('renewal');
  useEffect(() => {
    // 上报时候判断是否有数据
    if (!isEmpty(data)) {
      const eventData = {
        data: {
          _event: 'E_MKActivity_Entrance',
          activityConfig: {
            activityEnName: data?.activityEnName,
            activityZhName: data?.activityZhName,
            activityId: data?.activityId,
            startTime: data?.startTime,
            expireTime: data?.expireTime,
            activityType: data?.activityType,
            activityStatus: data?.activityStatus,
            subject: data?.subjects,
          },
          studentType: activityStudentType[data?.activityType as keyof typeof activityStudentType],
          dsSource,
        },
      };
      traceEvent(eventData);
      console.log('>>>E_MKActivity_Entrance', eventData);
    }
  }, [data]);
  const goRenewal = () => {
    const eventData = {
      data: {
        _event: 'C_MKActivity_Entrance',
        activityConfig: {
          activityEnName: data?.activityEnName,
          activityZhName: data?.activityZhName,
          activityId: data?.activityId,
          startTime: data?.startTime,
          expireTime: data?.expireTime,
          activityType: data?.activityType,
          activityStatus: data?.activityStatus,
          subject: data?.subjects,
        },
        studentType: activityStudentType[data?.activityType as keyof typeof activityStudentType],
        dsSource,
      },
    };
    traceEvent(eventData);
    console.log('>>>C_MKActivity_Entrance', eventData);
    router.push({
      pathname: `/m/home/renewalCourses`,
      query: {
        activityId: data?.activityId,
      },
    });
  };
  return (
    <div
      className={cls(style.container, 'ml-[16px] mr-[16px] mt-[24px] md:mb-[24px] md:ml-0 md:mr-0 md:mt-0')}
      id="renewal-entry"
    >
      <div className="relative min-h-[164px] overflow-hidden rounded-[12px] [background:linear-gradient(0deg,_rgba(255,216,133,0.3)_0%,_rgba(255,216,133,0.3)_100%),#fff] md:flex md:min-h-[100px] md:items-center md:justify-between md:rounded-[10px]">
        <img
          src={i18n?.language === 'zh' ? data?.webZhUrl : data?.webEnUrl}
          className="hidden w-full md:block"
          alt=""
        />
        <img
          src={i18n?.language === 'zh' ? data?.mobileZhUrl : data?.mobileEnUrl}
          className="block w-full md:hidden"
          alt=""
        />
        <button
          onClick={goRenewal}
          className="absolute z-[1] hidden h-9 shrink-0 cursor-pointer items-center justify-center gap-1 rounded-[200px] border-transparent bg-[#CD292A] px-[32px] text-[14px] font-semibold text-white md:right-[20px] md:top-[50%] md:m-0 md:flex md:h-[40px] md:translate-y-[-50%] md:px-[24px] md:text-[16px]"
        >
          {t('立即续费')}
        </button>
        <button
          onClick={goRenewal}
          className="absolute bottom-[16px] left-[50%] z-[1] flex h-9 shrink-0 translate-x-[-50%] cursor-pointer items-center justify-center gap-1 rounded-[200px] border-transparent bg-[#CD292A] px-[32px] text-[14px] font-semibold text-white md:m-0 md:hidden md:h-[40px] md:px-[24px] md:text-[16px]"
        >
          {t('立即续费')}
        </button>
      </div>
    </div>
  );
};

export default RenewalEntry;
